import { render } from "./attachmentViewer.vue?vue&type=template&id=bca47e0c&scoped=true"
import script from "./attachmentViewer.vue?vue&type=script&lang=js"
export * from "./attachmentViewer.vue?vue&type=script&lang=js"

import "./attachmentViewer.vue?vue&type=style&index=0&id=bca47e0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca47e0c"]])

export default __exports__